import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  GroupWithSubGroups,
  SubGroup,
  WalletAttributesAlertConfigService,
} from '../services/wallet-attributes-alert-config.service';
import { WalletEmailAlertConfigService } from '../services/wallet-email-alert-config.service';
import { Subscription } from 'rxjs';
import { EllipsisLoadingComponent } from 'src/app/shared/components/ellipsis-loading/ellipsis-loading.component';

@Component({
    selector: 'app-wallet-attributes-tab',
    templateUrl: './wallet-attributes-tab.component.html',
    styleUrls: ['./wallet-attributes-tab.component.scss'],
    imports: [CommonModule, FormsModule, EllipsisLoadingComponent]
})
export class WalletAttributesTabComponent implements OnInit, OnDestroy {
  @Input() walletId!: string;
  @Input() isAlert30Days: boolean = false;
  
  groupsWithSubgroups: GroupWithSubGroups[] = [];
  disabled = true;
  isLoading = false;

  subscriptions: Subscription[] = [];

  constructor(
    private readonly walletAttributesAlertConfigService: WalletAttributesAlertConfigService,
    private readonly walletEmailAlertConfigService: WalletEmailAlertConfigService
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.walletAttributesAlertConfigService
        .getGroupedIndicators$()
        .subscribe((indicators) => {
          this.groupsWithSubgroups = indicators;
        })
    );

    this.subscriptions.push(
      this.walletAttributesAlertConfigService
        .getIsLoadingIndicatorsList$()
        .subscribe((isLoading) => {
          this.isLoading = isLoading;
        })
    );

    this.subscriptions.push(
      this.walletEmailAlertConfigService
        .getWalletEmails$()
        .subscribe((emails) => {
          this.disabled = this.isAlert30Days && emails.length === 0;
        })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  onToggleSubgroupStatus(checked: boolean, subgroup: SubGroup) {
    subgroup.active = checked;
    this.walletAttributesAlertConfigService.toggleSubgroupAlertStatus(
      subgroup,
      this.walletId
    );
  }

  get isDisabled() {
    return this.disabled;
  }
}
